import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;

  constructor() {
    this.socket = io('https://server.oscemediko.id', {
      query: {
        channel: 'channel-once-UKNPDPD',
        secureKey: 'B6D63CECE15F1FE44B835E4AE2523'
      },
      transports: ['websocket'],
    });
  }

  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }

  listen(event: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(event, (data) => {
        subscriber.next(data);
      });
    });
  }
}
